<p-drawer
  [(visible)]="visible"
  position="left"
  styleClass="f-14"
  (onHide)="onDrawerHide()"
  [blockScroll]="true"
  dismissible="false"
  (onShow)="onDrawerShow()"
  aria-label="Left navigation menu"
  ariaCloseLabel="Close">
  <p-menu
    #mainMenu
    [model]="menuItems"
    styleClass="no-border"
    [ariaLabel]="'Main navigation menu'"></p-menu>
</p-drawer>
